/* eslint-disable react/require-default-props */
import React from 'react';
import { Label } from '../../../atoms/Label';
import './RadioStyles.scss';
import { RadioItem } from './RadioItem';
/**
 * Radio Component
 * Radio button group for selecting from a list of options
 * @version 2.1.0
 * @since 2026-01-28
 * @updated 2026-03-09 - Added per-option disabled and description, refactored to compose RadioItem
 */
export function Radio({ className, options, value, onChange, name, label, disabled = false, error }) {
    // React 17-compatible stable ID using useRef with lazy initialization
    const uniqueIdRef = React.useRef();
    if (!uniqueIdRef.current) {
        uniqueIdRef.current = `radio-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
    const uniqueId = uniqueIdRef.current;
    const labelId = `${uniqueId}-label`;
    const errorId = `${uniqueId}-error`;
    const hasLabel = !!label;
    const hasError = !!error;
    // Determine ARIA attributes for radiogroup
    const ariaLabelledBy = hasLabel && typeof label !== 'string' ? labelId : undefined;
    const ariaLabel = hasLabel && typeof label === 'string' ? label : undefined;
    const ariaDescribedBy = hasError ? errorId : undefined;
    const ariaInvalid = hasError;
    return (React.createElement("div", { className: className ? `${className} qmb-ui-radio-group` : 'qmb-ui-radio-group' },
        label && (React.createElement(Label, { id: labelId, className: "qmb-ui-radio-group__label" }, label)),
        React.createElement("div", { className: "qmb-ui-radio-group__options", role: "radiogroup", "aria-labelledby": ariaLabelledBy, "aria-label": ariaLabel, "aria-describedby": ariaDescribedBy, "aria-invalid": ariaInvalid }, options.map((option) => (React.createElement(RadioItem, { key: option.value, name: name, value: option.value, checked: value === option.value, onChange: () => onChange(option.value), label: option.label, description: option.description, disabled: disabled || option.disabled })))),
        error && (React.createElement("span", { id: errorId, className: "qmb-ui-radio-group__error" }, error))));
}
